/** Milliseconds in 14 days — PNL recalculation period from product rules. */
export const PNL_RECALC_INTERVAL_MS = 14 * 24 * 60 * 60 * 1000;

/**
 * Next PNL calculation instant: {@link pnlTime} + 14 days.
 * @param {string | Date | null | undefined} pnlTime ISO date from user payload (`pnlTime`)
 * @returns {Date | null}
 */
export function getNextPnlCalculationDate(pnlTime) {
  if (pnlTime == null || pnlTime === "") return null;
  const baseMs = new Date(pnlTime).getTime();
  if (!Number.isFinite(baseMs)) return null;
  return new Date(baseMs + PNL_RECALC_INTERVAL_MS);
}

/**
 * True when the next calculation time has been reached (or `pnlTime` is missing/invalid).
 * @param {string | Date | null | undefined} pnlTime
 */
export function isPnlCalculationDue(pnlTime) {
  const next = getNextPnlCalculationDate(pnlTime);
  if (!next) return true;
  return Date.now() >= next.getTime();
}

/**
 * Milliseconds until the next calculation; `0` if already due.
 * @param {string | Date | null | undefined} pnlTime
 * @returns {number | null} null when `pnlTime` is missing/invalid
 */
export function getMsUntilNextPnlCalculation(pnlTime) {
  const next = getNextPnlCalculationDate(pnlTime);
  if (!next) return null;
  return Math.max(0, next.getTime() - Date.now());
}
